import { useLocation } from "react-router-dom";

const useQuery = () => {
  const { search } = useLocation();
  const urlSearchParams = new URLSearchParams(search);
  return Object.fromEntries(urlSearchParams.entries());
};

export default useQuery;
